export enum TerminalLogStatusDTO {
  OK = 'OK',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  ERROR_STOP_NOT_ASSIGNED = 'ERROR_STOP_NOT_ASSIGNED',
  ERROR_TERMINAL_NOT_HANDLED = 'ERROR_TERMINAL_NOT_HANDLED',
  ERROR_BAD_QUEUE_CONTENT = 'ERROR_BAD_QUEUE_CONTENT',
}
